import type { LanguageOption } from './types';

// Config constants
export const DEFAULT_LANGUAGE_CONFIG_KEY = 'default_language';
export const CONFIG_TYPE_LANGUAGE = 'language';

// Language code to display name mapping
const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  'en-gb': 'English (UK)',
  'en-us': 'English (US)',
  ko: '한국어 (Korean)',
  es: 'Español (Spanish)',
  fr: 'Français (French)',
  de: 'Deutsch (German)',
  ja: '日本語 (Japanese)',
  zh: '中文 (Chinese)',
  pt: 'Português (Portuguese)',
  'pt-br': 'Português (Brasil)',
  'pt-pt': 'Português (Portugal)',
  ru: 'Русский (Russian)',
  it: 'Italiano (Italian)',
  pl: 'Polski (Polish)',
  nl: 'Nederlands (Dutch)',
  sv: 'Svenska (Swedish)',
  da: 'Dansk (Danish)',
  fi: 'Suomi (Finnish)',
  nb: 'Norsk (Norwegian Bokmål)',
  cs: 'Čeština (Czech)',
  hu: 'Magyar (Hungarian)',
  ro: 'Română (Romanian)',
  bg: 'Български (Bulgarian)',
  sk: 'Slovenčina (Slovak)',
  sl: 'Slovenščina (Slovenian)',
  et: 'Eesti (Estonian)',
  lv: 'Latviešu (Latvian)',
  lt: 'Lietuvių (Lithuanian)',
  el: 'Ελληνικά (Greek)',
  tr: 'Türkçe (Turkish)',
  uk: 'Українська (Ukrainian)',
  id: 'Bahasa Indonesia (Indonesian)',
};

/**
 * Get language options for default language dropdown
 * Returns English, Korean, and Japanese
 */
export const getLanguageOptions = (): LanguageOption[] => {
  const defaultLanguageCodes = ['en', 'ko', 'ja'];
  return defaultLanguageCodes.map((code) => ({
    value: code,
    label: LANGUAGE_NAMES[code],
  }));
};

/**
 * Get display name for a language code from supported languages API
 */
export const getSupportedLanguageName = (code: string): string => {
  return LANGUAGE_NAMES[code] || code.toUpperCase();
};

/**
 * Get all supported language codes
 * Returns an array of all language codes from LANGUAGE_NAMES
 */
export const getAllLanguageCodes = (): string[] => {
  return Object.keys(LANGUAGE_NAMES);
};
